import actions from './actions';

const initState = {
	dataDescribeImage: [],
	describeImageDetail: {},
	totalItems: 0,
	loading: false,
};

export default function describeImageReducer(state = initState, action) {
	switch (action.type) {
		case actions.GET_DESCRIBE_IMAGE:
			return { ...state, totalItems: 0, loading: true };
		case actions.GET_DESCRIBE_IMAGE_SUCCESS:
			let { data, totalItems } = action.payload;
			let res = data ? data : [];
			return { ...state, dataDescribeImage: res, totalItems, loading: false };

		case actions.GET_DESCRIBE_IMAGE_DETAIL:
			return { ...state, loading: true, totalItems: 0 };
		case actions.GET_DESCRIBE_IMAGE_DETAIL_SUCCESS: {
			let { data } = action.payload;
			let res = data ? data : {};
			return { ...state, describeImageDetail: res, loading: false };
		}

		case actions.SPEAKING_LOADING_FALSE: {
			return { ...state, loading: false };
		}

		default:
			return state;
	}
}
